module.exports = __webpack_public_path__ + "static/media/1_A1_14.cf583948.png";